<script lang="ts">
    import { onMount } from 'svelte';
    import PageHeader from '../components/PageHeader.svelte';
    import { getWorksites } from '../scripts/apiWorksites';
    import { storeWorksites, storeWorksitesError, storeWorksite } from "../scripts/worksite";
    import { addNotificationError }  from "../scripts/toaster";
    import Tile from '../components/Tile.svelte';
    import { idPageChantier } from '../scripts/router2';
    import { redirectTo } from '../scripts/router1';
    import { storeLanguage, lang_fr } from "../scripts/store";
    import { launchLoader, stopLoader } from "../scripts/utils";

    onMount(async () => {
        getWorksitesIfEmpty();
        window.scrollTo(0,0);
	});

    /**
     * getWorksitesIfEmpty
     */
     function getWorksitesIfEmpty() {
        if ($storeWorksites.length <= 0) {
            const returnValue = getWorksites();
            returnValue.then((data) => {
                if (!data) {
                    addNotificationError($storeWorksitesError);
                };
            });
        }
    }

    function selectWorksite(worksite_id) {
        storeWorksite.set($storeWorksites.filter((worksite) => worksite.id == worksite_id)[0]);
        redirectTo(idPageChantier, "?id="+worksite_id);
    }

</script>
    
<style lang="scss">

    .noschantiers {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        &__bloc {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
        }
        &__title {
            margin: 50px 0 50px 0;
            align-self: flex-start;
        }
        &__tiles {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            flex-wrap: wrap;
            align-items: center;
            margin: 0 32px 60px 32px;
            width: 100%;
        }
    }

    @include large {
        .noschantiers {
            &__tiles {
                flex-direction: row;
            }
            &__tile {
                cursor: pointer;
            }
        }
    }

</style>

<div class="noschantiers">
    {#if ($storeLanguage == $lang_fr)}
    <PageHeader props="nos chantiers"/>
    {:else}
    <PageHeader props="our projects"/>
    {/if}
    <div class="bloc noschantiers__bloc">
        <div class="noschantiers__title font__h3">
            {#if ($storeLanguage == $lang_fr)}
            Retrouvez ci-dessous l’ensemble des chantiers du collectif
            {:else}
            Find below all the projects of the collective
            {/if}
        </div>
        <div class="noschantiers__tiles">
            {#if ($storeWorksitesError != "")}
            <div class="getallarticles__article getallarticles__error">
                <p>Error : {$storeWorksitesError}</p>
            </div>
            {:else}
            {#key $storeWorksites}
            {#each $storeWorksites as worksite, i}
            <div class="noschantiers__tile" on:click={() => selectWorksite(worksite.id)} on:keydown={() => selectWorksite(worksite.id)}>
                {#if ($storeLanguage == $lang_fr)}
                <Tile props={{icon: "../assets/images/worksites/worksite"+i+".png", title: worksite.title_fr, text: ""}}/>
                {:else}
                <Tile props={{icon: "../assets/images/worksites/worksite"+i+".png", title: worksite.title_en, text: ""}}/>
                {/if}
            </div>
            {/each}
            {/key}
            {/if}
        </div>    
    </div>
</div>
